<template>
  <BaseButton1
    :class="{'is-loading': isLoading}"
    :disabled="isLocked || leftTime>0"
    @click="commit"
  >{{buttonText}}</BaseButton1>
</template>

<script>
import { format } from 'util'
import _ from 'lodash'
import { dcV1 } from '@/api'

import BaseButton1 from './BaseButton1.vue'

export default {
  components: {
    BaseButton1
  },
  props: {
    lang: {
      type: Object,
      default () {
        return {
          text: '发送验证码',
          loadingText: '%d秒后重试'
        }
      }
    },
    phone: {
      type: String,
      required: true
    },
    /**
     * @see https://github.com/nutspie/doc/blob/master/dartcome/v1.0/sms/phone/:phone.md#%E5%8F%82%E6%95%B0
     * 原因 1 修改手机号, 2 注册, 3 重置密码
     */
    reason: {
      type: Number,
      default: 0
    },
    dryrun: {
      type: Boolean,
      default: true
    },
    isDev: {
      type: Boolean,
      default: true
    }
  },
  data () {
    return {
      isLocked: false,
      isLoading: false,
      interval: 60000, // ms
      leftTime: 0,
      handleId: null
    }
  },
  computed: {
    buttonText () {
      if (this.leftTime <= 0) {
        return this.lang.text
      }
      return format(this.lang.loadingText, this.leftTime / 1000)
    }
  },
  methods: {
    reset () {
      clearInterval(this.handleId)
      this.leftTime = 0
    },
    start () {
      this.leftTime = this.interval
      this.handleId = setInterval(() => {
        this.leftTime -= 1000
        if (this.leftTime <= 0) {
          this.reset()
        }
      }, 1000)
    },
    async commit () {
      if (this.isLocked) {
        return
      }
      if (this.leftTime > 0) {
        return
      }
      try {
        let validate = await this.$validator.validateAll({
          username: this.phone
        })
        if (!validate) {
          throw new Error('手机号格式错误')
        }
        this.isLoading = true
        this.start()

        let options = {
          reason: this.reason,
          dryrun: this.dryrun
        }
        let res = await dcV1.post('/sms/phone/' + this.phone, options, {noAlert: true})
        let vcode = _.get(res, 'data.data.verify_code')
        if (vcode) {
          if (this.isDev) {
            this.$emit('updateCode', res.data.data.verify_code)
          }
        }
      } catch (e) {
        this.$emit('update:error', e)
        this.reset()
      } finally {
        this.isLoading = false
      }
    }
  },
  created () {
    this.$validator.attach({
      name: 'username',
      rules: 'required|regex:^.{11}$'
    })
  }
}
</script>

<style lang="postcss" scoped>
</style>



// WEBPACK FOOTER //
// src/components/button/SendVerifyCodeButton.vue